import { Button, Dialog, Divider, Stack, Typography } from "@mui/material";
import { ArrowLeft02Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import useTimeCounter from "@/hooks/useTimeCounter";
import { useEffect, useState } from "react";
import { Order, OrderStatus } from "@/types";

interface Props {
  order: Order;
  onGoBack?: () => void;
}

const OrderCanceledDialog = ({ order, onGoBack }: Props) => {
  const { now } = useTimeCounter();
  const [open, setOpen] = useState(false);

  const handleClose = (_: object, reason: "backdropClick" | "escapeKeyDown") => {
    if (reason === "backdropClick") return;
    setOpen(false);
  };

  useEffect(() => {
    if (!order.expiresAt) return;

    if (order.status === OrderStatus.REJECTED) {
      setOpen(true);
    }
  }, [order?.expiresAt, now]);

  return (
    <Dialog open={open} onClose={() => handleClose} disableEscapeKeyDown={true}>
      <Stack p={3} spacing={2}>
        <Stack pt={4} alignItems="center">
          <img width={150} alt="Pedido anulado" src="https://firebasestorage.googleapis.com/v0/b/menuapp-b44a8.appspot.com/o/assets%2Fwaiter-sad.webp?alt=media&token=a75dcdca-9e06-43a9-9179-7ecf289bb5de" />
          <Divider />
        </Stack>
        <Typography textAlign="center" variant="h3">Pedido anulado</Typography>
        <Typography textAlign="center" variant="body1">Lamentamos el inconveniente, no pudimos atender tu pedido a tiempo. Para evitar mas demoras tuvimos que anularlo.</Typography>
        <Typography textAlign="center" variant="body1">Le confirmamos que ningún cargo le fué realizado. Gracias por su comprensión...</Typography>
        <Button size="large" variant="outlined" startIcon={<HugeiconsIcon icon={ArrowLeft02Icon} />} onClick={onGoBack}>
          Regresar
        </Button>
      </Stack>
    </Dialog>
  );
};

export default OrderCanceledDialog;
